module.exports = new __parcel__URL__("73091293.b8079e1e.png").toString();